import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UnidadeNegocioNaturezaVendaModule } from '../natureza-venda';
import { UnidadeNegocioMercadoModule } from '../mercado';
import { UnidadeNegocioLinhaProducaoModule } from '../linha-producao';
import { UnidadeNegocioUsuarioModule } from '../usuario';

import { UnidadeNegocioFormComponent } from './unidade-negocio-form.component';
import { UnidadeNegocioConfiguracaoPedidoFormComponent } from './configuracao-pedido';

@NgModule({
    imports: [
        SharedModule,
        UnidadeNegocioNaturezaVendaModule,
        UnidadeNegocioMercadoModule,
        UnidadeNegocioLinhaProducaoModule,
        UnidadeNegocioUsuarioModule
    ],
    declarations: [
        UnidadeNegocioFormComponent,
        UnidadeNegocioConfiguracaoPedidoFormComponent
    ]
})
export class UnidadeNegocioFormModule { }
